import { render, staticRenderFns } from "./JadwalKripTable.vue?vue&type=template&id=ddebed56&"
import script from "./JadwalKripTable.vue?vue&type=script&lang=js&"
export * from "./JadwalKripTable.vue?vue&type=script&lang=js&"
import style0 from "./JadwalKripTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports